import { createStyles, makeStyles } from '@material-ui/core';

const useFooterStyle = makeStyles((theme) =>
    createStyles({
        root: {
            width: '100%',
            borderTop: `1px solid ${theme.palette.primary.light}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: theme.spacing(2),
            zIndex: 10,
            position: 'relative'
        },
        emailField: {
            border: `1px solid ${(theme.palette.primary as any)['700']}`,
            borderRadius: '99em',

            display: 'flex'
        },
        formContainer: {
            alignSelf: 'center',
            alignItems: 'center',
            marginTop: theme.spacing(7),
            marginBottom: theme.spacing(11)
        },
        formButtonText: { fontWeight: 500 },
        formButton: { padding: `${theme.spacing(2)}px ${theme.spacing(5)}px` },
        formLabel: { marginBottom: theme.spacing(2), marginLeft: theme.spacing(3) },
        sideNav: {
            gridColumnEnd: 'span 1',
            display: 'grid',
            gridTemplateColumns: 'repeat(2,1fr)',
            gridTemplateRows: '50% auto',

            justifySelf: 'center',
            // justifyContent: 'center',
            [theme.breakpoints.down('xs')]: {
                gridColumnEnd: 'span 4',
                width: '70vw'
            }
        },
        rightSideNav: {},
        middleNav: {
            gridColumnEnd: 'span 4',
            gridAutoRows: '1fr',
            gridTemplateRows: '50% auto',
            justifyItems: 'center',
            display: 'grid',
            gridTemplateColumns: 'repeat(4,1fr)',
            alignItems: 'start',
            justifySelf: 'center',
            [theme.breakpoints.down('xs')]: {
                width: '70vw',
                justifyContent: 'center'
            }
        },

        contentContainer: {
            maxWidth: 1000,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        navContainer: {
            marginBottom: theme.spacing(8),
            display: 'grid',
            gridTemplateColumns: 'repeat(6,1fr)',
            gridAutoRows: '1fr',
            width: '100%',
            columnGap: 16,
            justifyContent: 'center',
            [theme.breakpoints.down('xs')]: {
                gridTemplateColumns: 'repeat(4,1fr)'
            }
        },

        nonbreakText: {
            textAlign: 'center',
            cursor: 'pointer',

            gridColumnEnd: 'span 1',
            justifySelf: 'center',
            [theme.breakpoints.down('sm')]: {
                gridColumnEnd: 'span 2',
                // margin: `0 ${theme.spacing(2)}px`,
                marginBottom: theme.spacing(4)
            }
        },
        iconLink: { margin: theme.spacing(1) },
        icon: {
            width: '1.5em',
            height: '1.5em',
            [theme.breakpoints.down('xs')]: {
                width: '2em',
                height: '2em'
            }
        },
        middleNavContainer: {
            gridColumnEnd: 'span 4'

            // flex: 1
        },
        regularMarginBottom: { marginBottom: theme.spacing(4) },
        followus: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            [theme.breakpoints.down('xs')]: {
                gridColumnEnd: 'span 2'
            }
        },
        textInput: {
            width: 250,
            padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
            color: '#fff',
            [theme.breakpoints.down('xs')]: {
                width: 'auto'
            }
        },
        spacer: {
            margin: `${theme.spacing(8)}px 0`
        }
    })
);
export default useFooterStyle;
